<template>
  <b-row style="margin-top: 2em">
    <b-col>
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <h5 class="text-info m-1">{{ $t("globals.accepted_inquiries") }}:</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              small
              hover
              :items="accepted_inquiries"
              :fields="fields"
              @row-clicked="rowClicked"
            >
              <template v-slot:cell(accepted_at)="row">
                <div v-b-tooltip.hover :title="row.item.accepted_timezone">
                  {{ row.item.accepted_at ? row.item.accepted_at.substring(0, 10) : "" }}
                </div>
              </template>
              <template v-slot:cell(signed_by)="row">
                {{ [row.item.signed_first_name, row.item.signed_last_name].filter(Boolean).join(" ") }}
              </template>
              <template v-slot:cell(pdf)="row">
                <a
                  v-if="row.item.has_signed_pdf"
                  :href="acceptancePdfUrl(row.item.inquiry.id)"
                  target="_blank"
                  v-b-tooltip.hover
                  :title="$t('globals.show_pdf')"
                  @click.stop
                >
                  <v-icon name="regular/file-alt"></v-icon>
                </a>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>

      <!-- Accepted inquiry details -->
      <div v-if="selected">
        <b-row style="margin-top: 1em">
          <b-col>
            <b-card bg-variant="light">
              <h5 class="text-info m-1">
                
                <router-link
                  v-if="selected && selected.inquiry && selected.inquiry.id"
                  :to="{ name: 'inquiry', params: { id: selected.inquiry.id } }"
                  class="text-info"
                >
                  {{ $t("globals.accepted_inquiries") }} #{{ selected.inquiry ? selected.inquiry.inquiry_no : "" }}:
                </router-link>
                <span v-else>
                  {{ $t("globals.accepted_inquiries") }} #{{ selected.inquiry ? selected.inquiry.inquiry_no : "" }}:
                </span>
              </h5>
              <b-row>
                <b-col>
                  <span>{{ $t("globals.number") }}:</span>
                  {{ selected.inquiry ? selected.inquiry.inquiry_no : "" }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.accepted_at") }}:</span>
                  {{ selected.accepted_at ? selected.accepted_at.substring(0, 10) : "" }}
                  <span v-if="selected.accepted_timezone">({{ selected.accepted_timezone }})</span>
                </b-col>
                <b-col>
                  <span>{{ $t("globals.terms_version") }}:</span>
                  {{ selected.terms_version }}
                </b-col>
              </b-row>
              <b-row style="margin-top: 0.5em">
                <b-col>
                  <span>{{ $t("globals.signed_by") }}:</span>
                  {{ [selected.signed_first_name, selected.signed_last_name].filter(Boolean).join(" ") || "-" }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.has_signed_pdf") }}:</span>
                  <v-icon v-if="selected.has_signed_pdf" name="regular/check-square"></v-icon>
                  <v-icon v-else name="regular/square"></v-icon>
                </b-col>
                <b-col>
                  <a
                    v-if="selected.has_signed_pdf"
                    :href="acceptancePdfUrl(selected.inquiry.id)"
                    target="_blank"
                  >
                    <v-icon name="regular/file-alt"></v-icon>
                    {{ $t("globals.show_pdf") }}
                  </a>
                </b-col>
              </b-row>
            
              <br/>
              <b-row>
                <b-col>
                  <span>{{ $t("globals.contract_duration") }}:</span>
                  {{ selectedGroup.contract_duration }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.payment_term") }}:</span>
                  {{ selectedGroup.payment_term_name }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.total_price_one_time") }}:</span>
                  {{ currencyFormat(selectedGroup.total_price_one_time_with_discount, groupCurrency) }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.total_price_per_month") }}:</span>
                  {{ currencyFormat(selectedGroup.total_price_per_month_with_discount, groupCurrency) }}
                </b-col>
              </b-row>
              <b-row style="margin-top: 1em">
                <b-col>
                  <b-table small bordered :items="selectedGroup.items" :fields="itemFields">
                    <template v-slot:cell(price_one_time)="row">
                      {{ currencyFormat(row.item.price_one_time, row.item.currency) }}
                    </template>
                    <template v-slot:cell(price_per_month)="row">
                      {{ currencyFormat(row.item.price_per_month, row.item.currency) }}
                    </template>
                    <template v-slot:cell(discount)="row">
                      {{ currencyFormat(row.item.discount, row.item.currency) }}
                    </template>
                    <template v-slot:cell(vat)="row">
                      {{ row.item.vat }}%
                    </template>
                    <template v-slot:cell(is_device)="row">
                      <v-icon v-if="row.item.is_device" name="regular/check-square"></v-icon>
                      <v-icon v-else name="regular/square"></v-icon>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row v-if="selectedGroup.notes">
                <b-col>
                  <span>{{ $t("globals.notes") }}:</span>
                  {{ selectedGroup.notes }}
                </b-col>
              </b-row>
              <br/>
              <h5 class="text-info m-1">{{ $t("globals.customer_information") }}:</h5>
              <b-row>
                <b-col>
                  <span>{{ $t("globals.name") }}:</span> {{ selected.customer.company_name }}
                </b-col>
                <b-col>
                  <span>{{ $t("globals.vat") }}:</span> {{ selected.customer.company_vat }}
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span>{{ $t("globals.address") }}:</span>
                  {{ selected.customer.company_address }}, {{ selected.customer.company_postal_code }}
                  {{ selected.customer.company_city }}, {{ selected.customer.company_country }}
                </b-col>
              </b-row>
              <b-row style="margin-top: 1em">
                <b-col>
                  <h6 class="text-secondary">{{ $t("globals.contact") }}</h6>
                  <div>
                    {{ [selected.customer.contact_first_name, selected.customer.contact_last_name].filter(Boolean).join(" ") }}
                  </div>
                  <div>{{ selected.customer.contact_email }}</div>
                  <div>{{ selected.customer.contact_phone }}</div>
                  <div>
                    {{ selected.customer.contact_address }}, {{ selected.customer.contact_postal_code }}
                    {{ selected.customer.contact_city }}, {{ selected.customer.contact_country }}
                  </div>
                </b-col>
                <b-col>
                  <h6 class="text-secondary">{{ $t("globals.billing_information") }}</h6>
                  <div>
                    {{ [selected.customer.billing_first_name, selected.customer.billing_last_name].filter(Boolean).join(" ") }}
                  </div>
                  <div>{{ selected.customer.billing_email }}</div>
                  <div>{{ selected.customer.billing_phone }}</div>
                  <div>
                    {{ selected.customer.billing_address }}, {{ selected.customer.billing_postal_code }}
                    {{ selected.customer.billing_city }}, {{ selected.customer.billing_country }}
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

export default {
  props: {
    accepted_inquiries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: null,
      fields: [
        {
          key: "inquiry.inquiry_no",
          label: this.$t("globals.number"),
          sortable: true
        },
        {
          key: "customer.company_name",
          label: this.$t("globals.name"),
          sortable: true
        },
        {
          key: "accepted_at",
          label: this.$t("globals.accepted_at"),
          sortable: true
        },
        {
          key: "signed_by",
          label: this.$t("globals.signed_by")
        },
        {
          key: "pdf",
          label: this.$t("globals.show_pdf")
        }
      ],
      itemFields: [
        {
          key: "item_name",
          label: this.$t("globals.item")
        },
        {
          key: "item_type",
          label: this.$t("globals.type")
        },
        {
          key: "quantity",
          label: this.$t("globals.quantity")
        },
        {
          key: "price_one_time",
          label: this.$t("globals.price_once")
        },
        {
          key: "price_per_month",
          label: this.$t("globals.price_monthly")
        },
        {
          key: "discount",
          label: this.$t("globals.discount_per_item")
        },
        {
          key: "vat",
          label: this.$t("globals.vat")
        },
        {
          key: "is_device",
          label: this.$t("globals.is_device")
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getBackendUrl", "getLocale"]),
    selectedGroup() {
      return this.selected && this.selected.inquiry && this.selected.inquiry.inquiry_group
        ? this.selected.inquiry.inquiry_group[0]
        : null;
    },
    groupCurrency() {
      return this.selectedGroup && this.selectedGroup.items && this.selectedGroup.items.length > 0
        ? this.selectedGroup.items[0].currency
        : "EUR";
    }
  },
  methods: {
    currencyFormat,
    acceptancePdfUrl(inquiryId) {
      return `${this.getBackendUrl}/pdf_inquiries/${inquiryId}/acceptance?locale=${this.getLocale}`;
    },
    rowClicked(item) {
      // Don't toggle if user is selecting text
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) {
        return;
      }
      this.selected = this.selected === item ? null : item;
    }
  }
};
</script>
